var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-form",
    { ref: "disasterAreaForm", staticStyle: { "min-width": "250px" } },
    [
      _c("v-text-field", {
        ref: "name",
        attrs: {
          "hide-details": "",
          label: _vm.$t("disasterAvoidPolygons.name") + "*",
          rules: ["Required"]
        },
        model: {
          value: _vm.name,
          callback: function($$v) {
            _vm.name = $$v
          },
          expression: "name"
        }
      }),
      _vm._v(" "),
      _c("v-select", {
        attrs: {
          "hide-details": "",
          label: _vm.$t("disasterAvoidPolygons.disasterType") + "*",
          items: _vm.getDisasterTypes,
          "item-text": "name",
          "item-value": "id",
          rules: ["Required"]
        },
        model: {
          value: _vm.disasterTypeId,
          callback: function($$v) {
            _vm.disasterTypeId = $$v
          },
          expression: "disasterTypeId"
        }
      }),
      _vm._v(" "),
      _c("v-select", {
        attrs: {
          "hide-details": "",
          label: _vm.$t("disasterAvoidPolygons.disasterSubType"),
          items: _vm.getDisasterSubtypes,
          "item-text": "name",
          "item-value": "id",
          rules: ["Required"]
        },
        model: {
          value: _vm.disasterSubTypeId,
          callback: function($$v) {
            _vm.disasterSubTypeId = $$v
          },
          expression: "disasterSubTypeId"
        }
      }),
      _vm._v(" "),
      _c("v-textarea", {
        attrs: {
          "hide-details": "",
          height: "100",
          label: _vm.$t("disasterAvoidPolygons.description") + "*",
          rules: ["Required"]
        },
        model: {
          value: _vm.description,
          callback: function($$v) {
            _vm.description = $$v
          },
          expression: "description"
        }
      }),
      _vm._v(" "),
      _c("br"),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "v-btn",
            {
              staticStyle: { float: "left" },
              attrs: { disabled: _vm.readOnlyMode, color: "primary" },
              on: { click: _vm.save }
            },
            [_vm._v(_vm._s(_vm.$t("global.save")))]
          ),
          _vm._v(" "),
          _c(
            "v-btn",
            {
              staticStyle: { float: "left" },
              attrs: { color: "primary" },
              on: { click: _vm.cancel }
            },
            [
              _vm._v(
                _vm._s(
                  _vm.$store.getters.authorizationKey
                    ? _vm.$t("global.cancel")
                    : _vm.$t("global.close")
                )
              )
            ]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-252f3805", { render: render, staticRenderFns: staticRenderFns })
  }
}